const StandardStrike = require( '../abilities/StandardStrike' );

const OptionAttackEvent = function( battleState, actor, dmg ) {
	this.eventHandle = 'option_attack';
	this.magic = true;
	this.ranged = true;
	this.harm = true;
		
	const effects = ( actor, victim ) => {	
		new StandardStrike(this,battleState).execute( 
			actor, 
			victim, 
			dmg,
			true
		);
		this.actorId = actor.uid;
		this.victimId = victim.uid;	
		
		battleState.onBattleEvent( this );
	};

	this.execute = ( victim ) => {
		effects( actor, victim )
	};
};
module.exports = OptionAttackEvent
